<div style="height: 10px" (click)="handleExpansion($event)"></div>
@if (expanded) {
  <mat-card style="margin: 10px 0" appearance="outlined">
    @for (duration of apiService.apiCallDurations$ | keyvalue; track duration) {
      <mat-card-content>
        <table>
          <tbody>
            <tr>
              <td>
                <mat-chip> {{ duration.value | number: "1.0-2" }} ms</mat-chip>
              </td>
              <td>
                {{ duration.key }}
              </td>
            </tr>
          </tbody>
        </table>
      </mat-card-content>
    }
  </mat-card>
}
